export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10402.a6c119f1.jpg";